import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BaseEditService } from '../services';
import { Search } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MockEditService extends BaseEditService<any, any> {
  constructor() {
    super('', '');
  }

  search(model?: Search): Observable<any[]> {
    return of([]);
  }

  create(): Observable<any> {
    return of({} as any);
  }

  edit(id: string): Observable<any> {
    return of({});
  }

  save(model: any): Observable<string> {
    return of('');
  }

  delete(id: string): Observable<any> {
    return of({});
  }
}
